import { getConversionRequest } from 'src/api/ConversionRequest';
import { GET_CONVERSION, LOAD_DONE, LOAD_REQUEST } from '../types';
import { checkIfResponseOk } from './AuthActions';

export const getConversionAction = (values) => async (dispatch) => {
  try {
    dispatch({ type: LOAD_REQUEST });

    const { data } = await getConversionRequest(values);
    const error = checkIfResponseOk(data, dispatch);
    if (error) return error;

    dispatch({ type: GET_CONVERSION, payload: data.content.data.all });
    return 0;
  } catch (err) {
    dispatch({ type: LOAD_DONE });
    console.log('error here', err);
    return { error: 1, message: err.message };
  }
};
